import SortIndicator from './SortIndicator';

export default SortIndicator;
